export default {
    appkey: '2deaa618ea43d00f3fcea92a40e269e1', // 请输入自己的appkey
    appSecret: '' // 请输入自己的appSecret
}
